import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import ImageLoader from '../images/ImageLoader';
import BonusRewardCardModal from './BonusRewardCardModal';
import { getKeyValueText } from '../../util/getKeyValueText';

var BonusRewardCard = function BonusRewardCard(props) {
  var _Instructions$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$ctaLinks = props.ctaLinks,
      ctaLinks = _props$ctaLinks === void 0 ? [] : _props$ctaLinks,
      _props$rewardBadge = props.rewardBadge,
      rewardBadge = _props$rewardBadge === void 0 ? {} : _props$rewardBadge,
      _props$releaseRedempt = props.releaseRedemptionEngineV2,
      releaseRedemptionEngineV2 = _props$releaseRedempt === void 0 ? false : _props$releaseRedempt,
      _props$hasCart = props.hasCart,
      hasCart = _props$hasCart === void 0 ? false : _props$hasCart;
  var Image = model.Image,
      Name = model.Name,
      DisplayName = model.DisplayName,
      Description = model.Description,
      Instructions = model.Instructions,
      Expiration = model.Expiration,
      MenuTag = model.MenuTag;
  var modalModel = {
    Image: Image,
    Name: Name,
    DisplayName: DisplayName,
    Description: Description,
    Instructions: Instructions,
    Expiration: Expiration
  }; //state to show modal

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setModal = _useState2[1]; // modal cta state


  var _useState3 = useState({
    link: '#',
    buttonText: 'Got it!'
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      cta = _useState4[0],
      setCta = _useState4[1];

  var hide = function hide() {
    setModal(false);
  };

  var show = function show() {
    setModal(true);
  };

  useEffect(function () {
    if (releaseRedemptionEngineV2) {
      var _locationLink$fields, _locationLink$fields$;

      var formatCategory = function formatCategory(text) {
        var _text$toLowerCase;

        return text === null || text === void 0 ? void 0 : (_text$toLowerCase = text.toLowerCase()) === null || _text$toLowerCase === void 0 ? void 0 : _text$toLowerCase.replace(/\s/g, '_');
      };

      var formatInstruction = function formatInstruction(link) {
        var _link$toLowerCase;

        return link === null || link === void 0 ? void 0 : (_link$toLowerCase = link.toLowerCase()) === null || _link$toLowerCase === void 0 ? void 0 : _link$toLowerCase.replace(/\s/g, '-');
      };

      var defaultState = {
        link: '#',
        buttonText: 'Got it!'
      };
      var locationLink = ctaLinks.find(function (link) {
        var _link$fields, _link$fields$Category;

        return (formatCategory(link === null || link === void 0 ? void 0 : (_link$fields = link.fields) === null || _link$fields === void 0 ? void 0 : (_link$fields$Category = _link$fields.Category) === null || _link$fields$Category === void 0 ? void 0 : _link$fields$Category.value) || 'ctaLink') === 'location';
      });
      var locationLinkState = {
        link: (locationLink === null || locationLink === void 0 ? void 0 : (_locationLink$fields = locationLink.fields) === null || _locationLink$fields === void 0 ? void 0 : (_locationLink$fields$ = _locationLink$fields.Link) === null || _locationLink$fields$ === void 0 ? void 0 : _locationLink$fields$.value) || '/locations',
        buttonText: 'Find a Location'
      }; // If In-Store Only, show location link

      if ((Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) && formatInstruction(Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) === formatInstruction('In-Store Only')) {
        setCta(locationLinkState);
        return;
      } // If not available to redeem, show default state


      var validInstructions = [formatInstruction('Online Only'), formatInstruction('Curbside Only'), formatInstruction('Delivery Only'), formatInstruction('In-Store and Online')];

      if (!(Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) || !validInstructions.includes(formatInstruction(Instructions.value))) {
        setCta(defaultState);
        return;
      } // If no cart, show location link


      if (!hasCart) {
        setCta(locationLinkState);
        return;
      } else {
        var _menuLink$fields, _menuLink$fields$Link;

        // If has cart, try menu tag link first
        if (ctaLinks.length && (MenuTag === null || MenuTag === void 0 ? void 0 : MenuTag.value) && (MenuTag === null || MenuTag === void 0 ? void 0 : MenuTag.value) !== '') {
          var _menuTagLink$fields, _menuTagLink$fields$L;

          var menuTagValue = formatCategory(MenuTag.value) || 'menuTag'; // Try to find matching menu tag link first

          var menuTagLink = ctaLinks.find(function (link) {
            var _link$fields2, _link$fields2$Categor;

            return (formatCategory(link === null || link === void 0 ? void 0 : (_link$fields2 = link.fields) === null || _link$fields2 === void 0 ? void 0 : (_link$fields2$Categor = _link$fields2.Category) === null || _link$fields2$Categor === void 0 ? void 0 : _link$fields2$Categor.value) || 'ctaLink') === menuTagValue;
          });

          if (menuTagLink === null || menuTagLink === void 0 ? void 0 : (_menuTagLink$fields = menuTagLink.fields) === null || _menuTagLink$fields === void 0 ? void 0 : (_menuTagLink$fields$L = _menuTagLink$fields.Link) === null || _menuTagLink$fields$L === void 0 ? void 0 : _menuTagLink$fields$L.value) {
            setCta({
              link: menuTagLink.fields.Link.value,
              buttonText: 'View Menu'
            });
            return;
          }
        } // If no menu tag link, show menu link


        var menuLink = ctaLinks.find(function (link) {
          var _link$fields3, _link$fields3$Categor;

          return (formatCategory(link === null || link === void 0 ? void 0 : (_link$fields3 = link.fields) === null || _link$fields3 === void 0 ? void 0 : (_link$fields3$Categor = _link$fields3.Category) === null || _link$fields3$Categor === void 0 ? void 0 : _link$fields3$Categor.value) || 'ctaLink') === 'menu';
        });
        setCta({
          link: (menuLink === null || menuLink === void 0 ? void 0 : (_menuLink$fields = menuLink.fields) === null || _menuLink$fields === void 0 ? void 0 : (_menuLink$fields$Link = _menuLink$fields.Link) === null || _menuLink$fields$Link === void 0 ? void 0 : _menuLink$fields$Link.value) || '/menu',
          buttonText: 'View Menu'
        });
        return;
      }
    } else {
      setCta({
        link: '#',
        buttonText: 'Start order to redeem reward'
      });

      if (ctaLinks.length) {
        var _ctaLinkObj$fields, _ctaLinkObj$fields$Li;

        //find menu tag in cta links
        var ctaLinkObj = ctaLinks.find(function (link) {
          var _link$fields4, _link$fields4$Categor, _link$fields4$Categor2, _link$fields4$Categor3, _MenuTag$value, _MenuTag$value$toLowe;

          return ((link === null || link === void 0 ? void 0 : (_link$fields4 = link.fields) === null || _link$fields4 === void 0 ? void 0 : (_link$fields4$Categor = _link$fields4.Category) === null || _link$fields4$Categor === void 0 ? void 0 : (_link$fields4$Categor2 = _link$fields4$Categor.value) === null || _link$fields4$Categor2 === void 0 ? void 0 : (_link$fields4$Categor3 = _link$fields4$Categor2.toLowerCase()) === null || _link$fields4$Categor3 === void 0 ? void 0 : _link$fields4$Categor3.replace(/\s/g, '_')) || 'ctaLink') === ((MenuTag === null || MenuTag === void 0 ? void 0 : (_MenuTag$value = MenuTag.value) === null || _MenuTag$value === void 0 ? void 0 : (_MenuTag$value$toLowe = _MenuTag$value.toLowerCase()) === null || _MenuTag$value$toLowe === void 0 ? void 0 : _MenuTag$value$toLowe.replace(/\s/g, '_')) || 'menuTag');
        });

        if (ctaLinkObj && ((_ctaLinkObj$fields = ctaLinkObj.fields) === null || _ctaLinkObj$fields === void 0 ? void 0 : (_ctaLinkObj$fields$Li = _ctaLinkObj$fields.Link) === null || _ctaLinkObj$fields$Li === void 0 ? void 0 : _ctaLinkObj$fields$Li.value)) {
          setCta({
            link: ctaLinkObj.fields.Link.value,
            buttonText: 'Start order to redeem reward'
          });
        }
      }
    }
  }, [Instructions === null || Instructions === void 0 ? void 0 : Instructions.value, MenuTag === null || MenuTag === void 0 ? void 0 : MenuTag.value, ctaLinks, hasCart, releaseRedemptionEngineV2]);
  var rewardBadgeText = (Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) ? getKeyValueText(Instructions === null || Instructions === void 0 ? void 0 : Instructions.value, rewardBadge === null || rewardBadge === void 0 ? void 0 : rewardBadge.value) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BonusRewardCardModal, {
    show: showModal,
    hide: hide,
    model: modalModel,
    cta: cta,
    releaseRedemptionEngineV2: releaseRedemptionEngineV2,
    rewardBadgeText: rewardBadgeText
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-reward-card",
    onClick: show
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  }), releaseRedemptionEngineV2 && (Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) && rewardBadgeText && rewardBadgeText !== '' && ['App Only', 'Online Only', 'In-Store Only', 'Retail Only'].includes(Instructions === null || Instructions === void 0 ? void 0 : Instructions.value) && /*#__PURE__*/React.createElement("div", {
    className: "cb-bonus-reward-card__tag cb-bonus-reward-card__tag--".concat(Instructions === null || Instructions === void 0 ? void 0 : (_Instructions$value = Instructions.value) === null || _Instructions$value === void 0 ? void 0 : _Instructions$value.toLowerCase().replace(/\s/g, '-'))
  }, rewardBadgeText)), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__header'
  }, DisplayName.value), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__copy'
  }, Name.value), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-card__expiration'
  }, Expiration.value && "Expires ".concat(Expiration.value)))));
};

export default BonusRewardCard;